import { apiClient } from '@/lib/apiClient';

export type Role = 'EndUser' | 'ITAgent' | 'ITAdmin';

export interface Me {
  entraObjectId: string | null;
  displayName: string | null;
  email: string | null;
  role: Role;
}

export const meApi = {
  /** GET /api/me — the signed-in user's identity + resolved role. */
  get: (getAccessToken: () => Promise<string>, signal?: AbortSignal): Promise<Me> =>
    apiClient.get<Me>('/api/me', { getAccessToken, signal })
};
